<script>
export default {
  name: 'movePageOnSwipe',
  components: {
  },
  props: {
    leftMoveTo: {
      type: Object,
      default: () => {
        return {}
      },
    },
    rightMoveTo: {
      type: Object,
      default: () => {
        return {}
      },
    },
    isLeftMoveTo: {
      type: Boolean,
      default: true,
    },
    isRightMoveTo: {
      type: Boolean,
      default: true,
    },
  },
  created() {
  },
  methods: {
    onSwipeLeft() {
      if (!this.isLeftMoveTo) { return; }
      this.$router.push(this.leftMoveTo);
    },
    onSwipeRight() {
      if (!this.isRightMoveTo) { return; }
      this.$router.push(this.rightMoveTo);
    },
  }
};
</script>

<template>
  
  <div :class="$mq">
    <v-touch class="left" v-on:swiperight="onSwipeRight" v-if="isRightMoveTo"></v-touch>
    <slot />
    <v-touch class="right" v-on:swipeleft="onSwipeLeft" v-if="isLeftMoveTo"></v-touch>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .left {
    @include fixed100;
    right: auto;
    width: 5%;
    cursor: grab;
    z-index: $zIndexSwipe;
    // background: red
  }
  .right {
    @include fixed100;
    left: auto;
    width: 5%;
    cursor: grab;
    z-index: $zIndexSwipe;
    // background: red
  }
  .viewLg {
    .left, .right {
      display: none;
    }
  }
</style>
